import React from 'react';
import { Accordion } from './accordion';

export const ProjectModal = ({ isOpen, onClose, project, t }) => {
  // Close on Escape key
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen || !project) return null;

  const popup = project.popup;
  if (!popup) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm animate-fadeIn" />
      
      {/* Modal Content */}
      <div 
        className="relative w-full max-w-4xl max-h-[90vh] overflow-hidden bg-black/95 border border-white/10 rounded-lg shadow-2xl animate-slideUp"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Terminal Header */}
        <div className="flex items-center justify-between p-4 border-b border-white/10 bg-black/50">
          <div className="flex items-center gap-3">
            <div className="flex gap-2">
              <span className="w-3 h-3 rounded-full bg-red-500 cursor-pointer hover:brightness-125" onClick={onClose} />
              <span className="w-3 h-3 rounded-full bg-yellow-500" />
              <span className="w-3 h-3 rounded-full bg-green-500" />
            </div>
            <span className="text-green-400 font-mono text-sm">root@next3-lab</span>
            <span className="text-white/30 font-mono text-sm">~</span>
            <span className="text-amber font-mono text-sm">cat ./projects/{popup.id || 'dossier'}.md</span>
          </div>
          <button 
            onClick={onClose}
            className="text-white/50 hover:text-white font-mono text-sm transition-colors"
          >
            [ESC]
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="overflow-y-auto max-h-[calc(90vh-120px)] p-6">
          {/* Title Section */}
          <div className="mb-6 pb-6 border-b border-white/10">
            <div className="flex items-center gap-3 mb-2">
              <span className={`text-xs font-mono px-2 py-1 rounded ${popup.statusColor || 'bg-blue-500/20 text-blue-400'}`}>
                [{popup.status || 'ACTIVE'}]
              </span>
            </div>
            <h2 className="text-3xl font-mono font-bold text-white mb-2">
              {popup.fullTitle}
            </h2>
            <p className="text-amber font-mono text-lg">
              {popup.subtitle}
            </p>
          </div>

          {/* Accordion Sections */}
          <Accordion 
            items={popup.sections} 
            defaultOpen={[0]}
          />

          {/* Footer CTA */}
          <div className="mt-6 pt-6 border-t border-white/10 flex justify-center">
            <button 
              onClick={() => {
                onClose();
                setTimeout(() => {
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
              }}
              className="relative px-8 py-3 text-[#FF6C00] font-mono hover:text-black transition-all duration-300 hover:-translate-y-1 hover:drop-shadow-[0_4px_6px_rgba(255,108,0,0.4)]"
              style={{
                background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 100 100'%3E%3Cpolygon points='10,0 100,0 100,70 90,100 0,100 0,30' fill='rgba(255,108,0,0.2)' stroke='%23FF6C00' stroke-width='2' vector-effect='non-scaling-stroke'/%3E%3C/svg%3E")`,
                backgroundSize: "100% 100%",
                backgroundRepeat: "no-repeat"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 100 100'%3E%3Cpolygon points='10,0 100,0 100,70 90,100 0,100 0,30' fill='%23FF6C00' stroke='%23FF6C00' stroke-width='2' vector-effect='non-scaling-stroke'/%3E%3C/svg%3E")`;
                e.currentTarget.style.backgroundSize = "100% 100%";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 100 100'%3E%3Cpolygon points='10,0 100,0 100,70 90,100 0,100 0,30' fill='rgba(255,108,0,0.2)' stroke='%23FF6C00' stroke-width='2' vector-effect='non-scaling-stroke'/%3E%3C/svg%3E")`;
                e.currentTarget.style.backgroundSize = "100% 100%";
              }}
            >
              &gt; REQUEST_DEMO.sh
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
